import classNames from 'classnames';
import React, { memo } from 'react';
import { NavLink } from 'react-router-dom';

import './SidebarLink.scss';

const SidebarLink = ({ linkTo, icon, title, disabled = false }) => {
  const classes = classNames('sidebarLink', { 'sidebarLink--disabled': disabled });

  return (
    <NavLink to={linkTo} title={title} className={classes} activeClassName="sidebarLink--active">
      {icon}
      {disabled && <span className="sidebarLink__disabledInfo">soon</span>}
    </NavLink>
  );
};

export default memo(SidebarLink);
